import createActions from 'utils/redux/createActions'

export default createActions([
    'PREDEFINED_FILTER_SET'
])



// WEBPACK FOOTER //
// ./src/actions/filters.js